import * as React from 'react';

import { markAsClosed } from '@/packages/MapBanners/browser/utils/banner';

import { RealtorReportBanner } from '../../components/RealtorReportBanner';
import { EBanners, EXPIRES_TIME_FOR_REALTOR_REPORT, REALTOR_REPORT_CLOSED_COOKIE_KEY } from '../../constants/banners';

const REALTOR_REPORT_URL = '/kalkulator-nedvizhimosti/';

interface IRealtorReportBannerContainerProps {
  open: boolean;
  onClose(): void;
}

export const RealtorReportBannerContainer: React.FC<IRealtorReportBannerContainerProps> = props => {
  const { onClose, open } = props;

  const handleClose = React.useCallback(() => {
    onClose();
    markAsClosed(REALTOR_REPORT_CLOSED_COOKIE_KEY, EBanners.RealtorReport, EXPIRES_TIME_FOR_REALTOR_REPORT);
  }, [onClose]);

  if (!open) {
    return null;
  }

  return <RealtorReportBanner redirectUrl={REALTOR_REPORT_URL} onClose={handleClose} />;
};
